import { styled } from "@mui/material/styles";
import { IconButton } from "@mui/material";

const TableWrapper = styled("div")(({ theme }) => ({
  marginTop: "20px",
  marginBottom: "50px",

  "& .TableContainer ": {
    "&::-webkit-scrollbar": {
      height: "8px",
      backgroundColor: "#F4F4F4",
    },

    "&::-webkit-scrollbar-thumb": {
      borderRadius: "4px",
      backgroundColor: "#888",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#555",
    },
    "&::-webkit-scrollbar-track": {
      borderRadius: "4px",
      backgroundColor: "#F4F4F4",
    },
  },

  "& .table_head th": {
    paddingTop: "0px",
    paddingBottom: "10px",
    whiteSpace: "nowrap",
  },
  "& .table_head th": {
    borderBottom: "0px",
  },
  "& .table_head th span": {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "19px",
    color: "rgba(11, 11, 11, 0.7)",
    fontFamily: theme.typography.fontFamily,
    whiteSpace: "nowrap",
  },
  "& .table_head th span svg": {
    color: "#0B0B0BB2",
  },
  "& .table_head th span.Mui-active  svg": {
    color: "#0B0B0BB2",
  },

  "& .table_body > :not(:last-child)": {
    borderBottom: "8px solid #fff",
  },

  "& .table_body tr": {
    background: "#F4F4F4",
  },

  "& .table_body  td": {
    borderBottom: "none",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "19px",
    color: "#0B0B0B",
    whiteSpace: "nowrap",
    fontFamily: theme.typography.fontFamily,
  },
  "& .table_body  td span.statusSpan": {
    padding: "4px 11px",
    borderRadius: "40px",
  },
  "& .table_body  td span.status_pending": {
    background: "rgba(78, 64, 166, 0.1)",
    color: "#4E40A6",
  },
  "& .table_body  td span.status_approved": {
    background: "rgba(0, 200, 8, 0.1)",
    color: "#00C808",
  },
  "& .table_body  td span.status_arrived": {
    background: "rgba(255, 153, 0, 0.15)",
    color: "#FF9900",
  },
  "& .table_body  td span.status_order_picked": {
    background: "rgba(0, 117, 255, 0.1)",
    color: "#0075FF",
  },
  "& .table_body  td span.status_driver": {
    background: "rgba(195, 0, 106, 0.15)",
    color: "#C3006A",
  },
  "& .table_body  td span.status_completed": {
    background: "rgba(15, 184, 0, 0.1)",
    color: "#0FB800",
  },
  "& .table_body  td span.status_active": {
    background: "rgba(0, 200, 8, 0.1)",
    color: "#00C808",
  },
  "& .table_body  td span.status_non": {
    background: "rgba(255, 0, 0, 0.1)",
    color: "#FF0000",
  },
  "& .table_body  td span.status_assign": {
    background: "rgba(78, 64, 166, 0.1)",
    color: "#4E40A6",
  },
  "& .table_body  td span.status_broadcasting": {
    background: "rgba(211, 128, 29, 0.15)",
    color: "#D3801D",
  },
  "& .table_body  td span.status_cancelled": {
    background: "rgba(255, 0, 0, 0.1)",
    color: "#FF0000",
  },
  "& .table_body  td span.status_in.route": {
    background: "rgba(0, 132, 255, 0.1)",
    color: "#0085FF",
  },
  "& .table_body  td span.status_paid": {
    background: "rgba(15, 184, 0, 0.1)",
    color: "#0FB800",
  },
  "& .table_body  td span.status_unpaid": {
    background: "rgba(78, 64, 166, 0.1)",
    color: "#4E40A6",
  },
  "& .table_body  td span.status_inactive": {
    background: "rgba(255, 153, 0, 0.15)",
    color: "#FF9900",
  },
  "& .table_body  td span.status_order_delivered": {
    background: "#27ae60",
    color: "#ffffff",
  },
  "& .table_body  td span.status_driver_arrived": {
    background: "#FF9900",
    color: "#ffffff",
  },
  "& .table_body  td span.status_driver_on_way_to_pickup": {
    background: "#0075FF",
    color: "#ffffff",
  },
  "& .table_body  td span.status_driver_departed": {
    background: "#C3006A",
    color: "#ffffff",
  },
  "& .table_body  td span.status_driver_reached_at_drop_off": {
    background: "#9E00FF",
    color: "#ffffff",
  },
  "& .table_body  td span.status_price_quote": {
    background: "#9E00FF",
    color: "#ffffff",
  },
  "& .table_body  td span.status_driver_assigned": {
    background: "rgba(0, 200, 8, 0.1)",
    color: "#00C808",
    background: "rgba(78, 64, 166, 0.1)",
    color: "#4E40A6",
  },
}));

const ActionButtonMain = styled(IconButton)(({ theme }) => ({
  background: "#D9D9D9",
  padding: "5px 5px",
  "&:hover": { background: "#D9D9D9" },
  "& svg": { color: "#0B0B0B", fontSize: "20px" },
}));
const ActionButtonItem = styled(IconButton)(({ theme }) => ({
  background: "#D9D9D9",
  padding: "7px 18px",
  width: "100%",
  background: "rgba(58, 54, 219, 0.1)",
  borderRadius: "6px",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "15px",
  lineHeight: "19px",
  color: "#007BEC",
  justifyContent: "start",
  gap: "10px",
  fontFamily: theme.typography.fontFamily,
  marginBottom: "10px",
  "& svg": { fontSize: "18px" },
  "&:hover": { background: "rgba(58, 54, 219, 0.1)" },
  "& img": { width: "20px" },
  "&.block__btn": {
    backgroundColor: "rgba(255, 0, 0, 0.2)",
    color: "#FF0000",
    "& svg": { fontSize: "18px" },
  },

  "&.delete__btn": {
    backgroundColor: "rgba(255, 105, 180, 0.3)",
    color: "#EF0081",
  },
  "&.approve__btn": {
    backgroundColor: "rgba(0, 200, 8, 0.1)",
    color: "#00C808",
  },
  "&.broadcastjob__btn": {
    backgroundColor: "rgba(211, 128, 29, 0.15)",
    color: "#D3801D",
  },
  "&:last-child": {
    marginBottom: "0",
  },

  "&.Mui-disabled": {
    backgroundColor: "#f2f2f2",
    color: "#000",
    cursor: "not-allowed",
    pointerEvents: "auto",
    opacity: 0.5,
    "&:hover": {
      backgroundColor: "#f2f2f2",
    },
    "& img": {
      opacity: 0.5,
    },
    "& svg": {
      opacity: 0.5,
    },
  },
}));

export { TableWrapper, ActionButtonMain, ActionButtonItem };
